// Shared GBP formatting for the app — whole-pound display, e.g. "£2,312".
// Two entry points so call sites are unambiguous about their input unit:
// most data is in pounds; Stripe/price amounts are in pence.
const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
})

// Price amounts (Stripe, in pence) can carry pence — £4.99 must render as
// "£4.99", not round to "£5" — but whole-pound prices stay clean ("£19"). So
// use 2 dp for non-round-pound amounts (→ "£4.99", "£12.50") and 0 dp for whole
// pounds (→ "£19"), rather than letting the formatter trim a trailing zero.
const GBP_PENCE = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const formatGBP = (pounds: number) => GBP.format(pounds)
export const formatGBPFromPence = (pence: number) =>
  pence % 100 === 0 ? GBP.format(pence / 100) : GBP_PENCE.format(pence / 100)
